import { Entry } from '../Entry'

export function Entry20220728() {
  return (
    <Entry title="28/07/2022 - v3.1.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12715/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
